import React from 'react';

interface IInvertedTriangleSmall_08 {
    fill: string;
    id?: string;
}

const InvertedTriangleSmall_08: React.FC<IInvertedTriangleSmall_08> = ({ fill, id }) => {
  return (
  <svg width="222" height="224" viewBox="0 0 222 224" fill="none" xmlns="http://www.w3.org/2000/svg">
  <mask id="mask0_1825_700" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="222" height="224">
  <path d="M111 224L222 -8.16995e-06L0 -8.16995e-06L111 224Z" fill={fill}/>
  </mask>
  <g mask="url(#mask0_1825_700)">
  <rect y="-616" width="6" height="1456" fill={fill}/>
  <rect x="18" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="36" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="54" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="72" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="90" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="108" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="126" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="144" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="162" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="180" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="198" y="-616" width="6" height="1456" fill={fill}/>
  <rect x="216" y="-616" width="6" height="1456" fill={fill}/>
  </g>
  </svg>
  );
  };
  export default InvertedTriangleSmall_08;
